// extracted by mini-css-extract-plugin
export var excerpt = "SearchHitContact-module--excerpt--dz272";
export var image = "SearchHitContact-module--image--Z1ncV";
export var meta = "SearchHitContact-module--meta--yKhJ2";
export var teaser = "SearchHitContact-module--teaser--hBJI5";
export var teaserHeader = "SearchHitContact-module--teaserHeader--rVTtM";
export var teaserWImage = "SearchHitContact-module--teaserWImage--If1Xy";
export var title = "SearchHitContact-module--title---SK84";
export var titleLink = "SearchHitContact-module--titleLink--qrgOj";